import { Entries } from "./entries";

export class Race {
  id!: string;
  displayName!: string;
  hasChildren?: boolean;
  raceName?: string;
  venueCode?: string;
  raceDatetime?: IDateField;
  raceDistance?: string;
  group?: string;
  trackMap?: IImageField;
  raceDescription?: string;
  entries?: Entries;

  constructor(data?: IRace){    
    this.id = data?.id || "";
    this.displayName = data?.displayName || "";
    this.hasChildren = data?.hasChildren;
    this.raceName = data?.raceName?.value;
    this.venueCode = data?.venueCode?.value;
    this.raceDatetime = data?.raceDatetime;
    this.raceDistance = data?.raceDistance?.value;
    this.group = data?.group?.value;
    this.trackMap = data?.trackMap?.targetItem?.trackImage
    this.raceDescription = data?.raceDescription?.value; 
    this.entries = new Entries(data?.entries?.[0])
  }
}